<div #header mat-dialog-title>
  Mass Update Student Attendance
</div>

<mat-dialog-content style="padding-top: 10px !important;">
  <div style="width:100%;display: inline-block;">
    <tyl-form-field label="Attendance Code">
      <mat-select #periodCode [(ngModel)]="selectedAttendanceCodeId" name="stateReporting" id="stateReporting">
        <mat-option *ngFor="let item of attendanceCodes;" [value]="item.Id">
          <span>{{item.CodeDescription}}</span>
        </mat-option>
      </mat-select>
    </tyl-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions #footer>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="Save.png" label="Apply" (click)="applyClick()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (click)="closeClick()"></tyl-button>
  </div>
</mat-dialog-actions>
